import { Product } from '@@types'
import { useTranslation } from 'react-i18next'

import { useModalStore } from '@features/modal'

import ProductsSimilar from '@widgets/products-similar/ui'


export default function useProductsSimilarModal () {
  const { t: tp } = useTranslation('product')
  const { openModal, closeModal } = useModalStore()

  const openProductsSimilarModal = (product: Product) => {
    openModal(
      'productsSimilar',
      <ProductsSimilar product={product} title={tp('similar_products')} />,
      {
        hideIconClose: true,
      },
    )
  }

  const closeProductsSimilarModal = () => {
    closeModal('productsSimilar')
  }

  return {
    openProductsSimilarModal,
    closeProductsSimilarModal,
  }
}
